import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedNoteType: "",
  loading: false,
  addbillingclientLoading: false,
//   loadingNote_Types: false,

allbillingclient: [],
//   noteTypes: [],
//   allNotesTypes: [],
//   fieldType: [],
//   notesAgainstTypes: []
};

export const billingclientState = createSlice({
  name: "billingclient",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setAddbillingclientLoading(state, action) {
      return {
        ...state,
        addbillingclientLoading: action?.payload
      };
    },

    setAllBillingclient(state, action) {
        return {
          ...state,
          loading: false,
          allbillingclient: action?.payload,
        //   addFacilityLoading: false
        };
      },



    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddbillingclientLoading,
  setAllBillingclient,
 
} = billingclientState.actions;
export default billingclientState.reducer;
